export enum Region {
  NORTH_EAST = 'North East',
  NORTH_WEST = 'North West',
  YORKSHIRE_AND_THE_HUMBER = 'Yorkshire and the Humber',
  EAST_MIDLANDS = 'East Midlands',
  WEST_MIDLANDS = 'West Midlands',
  EAST_OF_ENGLAND = 'East of England',
  LONDON = 'London',
  SOUTH_EAST = 'South East',
  SOUTH_WEST = 'South West',
}
